import React from "react";
import { Container } from "react-bootstrap";
import group from "../../../../Asset/cta-ng.png";
import { useNavigate } from "react-router-dom";

const Last = () => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/ContactUs");
  };
  return (
    <>
      <section className="sixth-mobileApp-section">
        <Container>
          <div className="mob-dev-cta">
            <div className="row align-items-center p-4">
              <div className="col-xl-8 col-md-8 ">
                <div className="sec-6-cta-card">
                  <h3>
                    Accelerate Your{" "}
                    <strong className="text-skyblue">D2C Growth</strong>
                  </h3>
                  <p onClick={handleNavigate} className="btn btn-primary">
                    Book Free Consultation Now
                  </p>
                </div>
              </div>
              <div className="col-xl-4 col-md-4">
                <div className="cta-bg">
                  <img alt="main" src={group} className="w-100" />
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Last;
